import { explicitMaybe } from '@execonline-inc/decoders';
import { identity } from '@kofno/piper';
import { Decoder, array, field, nullable, number, oneOf, string, succeed } from 'jsonous';
import { stringLiteral } from '../../../../../Decoders';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { ToString } from '../../../../Options/Types';
import {
  FilterOption,
  FilterOptions,
  FilterOptionsResource,
  OptionType,
  ParticipantAndGroupOption,
} from './Types';

const optionTypeDecoder: Decoder<OptionType> = oneOf([
  stringLiteral<OptionType>('group'),
  stringLiteral<OptionType>('participant'),
]);

const optionWithTypeDecoder = <T extends ToString>(
  decoder: Decoder<T>,
): Decoder<ParticipantAndGroupOption<T>> =>
  succeed({})
    .assign('label', field('label', string))
    .assign('value', field('value', decoder))
    .assign('type', field('type', nullable(optionTypeDecoder)))
    .assign('email', field('email', explicitMaybe(string)))
    .assign('participantCount', field('participant_count', explicitMaybe(number)))
    .assign('initials', field('initials', explicitMaybe(string)))
    .map<ParticipantAndGroupOption<T>>(identity);

const filterOptionWithTypeDecoder: Decoder<FilterOption> = resourceDecoder(
  optionWithTypeDecoder(string),
);

const filterOptionsWithTypeDecoder: Decoder<FilterOptions> = array(filterOptionWithTypeDecoder);

export const filterOptionsResourceDecoder: Decoder<FilterOptionsResource> = resourceDecoder(
  filterOptionsWithTypeDecoder,
);
